import React, { useEffect, useState } from "react";
import logo from "../../assets/images/Logo-white.svg"; // change path as needed
import { MdPhone, MdEmail, MdLocationOn } from "react-icons/md";
import { Link } from "react-router-dom";
import { FaLinkedin, FaFacebook, FaInstagram, } from 'react-icons/fa';
import twiterIcon from "../../assets/icons/twitter (3) 2 (1).png"
import youtubeIcon from "../../assets/icons/video 1.png"
import { Getdata } from "../../helpers/api.service";
const links = [
  { name: "Terms and Conditions", path: "/terms-conditions" },
  { name: "Privacy Policy", path: "/privacy-policy" },
  
];

const QuickLinks = [
  { name: "About Us", path: "/about" },
  { name: "Education", path: "/education" },
  { name: "Extracurricular", path: "/extra-curricular/Arts" },
  { name: "News", path: "/news" },
  { name: "Contact Us", path: "/contact" },
];

// ...imports unchanged...

const Footer = (props) => {
  const [list, setList] = useState([]);
  const [policies, setPolicies] = useState([]);

  const XIcon = ({ className }) => (
    <img src={twiterIcon} alt="Twitter/X" style={{ paddingTop: "2px" }} />
  );
  const Youtube = ({ className }) => <img src={youtubeIcon} alt="YouTube" />;

  // 1) Icon components keyed by normalized platform names
  const platformIconMap = {
    linkedin: <FaLinkedin className="text-blue-500 text-2xl" />,
    twitter: <XIcon className="text-white text-2xl" />,
    x:       <XIcon className="text-white text-2xl" />,
    instagram: (
      <FaInstagram
        className="text-white text-2xl rounded-lg"
        style={{
          background: "linear-gradient(45deg, #FFDD55, #FF543E, #C837AB)",
          padding: "2px",
        }}
      />
    ),
    facebook: <FaFacebook className="text-blue-600 text-2xl" />,
    youtube:  <Youtube className="text-red-600 text-2xl" />,
  };

  // Helper to normalize incoming platform names
  const normalize = (p = "") =>
    p.trim().toLowerCase().replace(/\s+/g, ""); // e.g., "You Tube" -> "youtube"

  // 2) Build social links from API data
  const socialLinks = list
    .map((item) => {
      const key = normalize(item.platform);
      const icon = platformIconMap[key];
      if (!icon || !item.link) return null; // skip unknown or missing links
      return {
        name: item.platform,
        href: item.link,
        icon,
      };
    })
    .filter(Boolean);

  const fetchData = () => {
    Getdata(
      process.env.REACT_APP_URL +
        `/front/social_media/${process.env.REACT_APP_SUBDOMAIN}`
    )
      .then((res) => {
        // Expecting an array like the sample you provided
        console.log("social::::::::::::uuuuuuuuuuuu::::::::::::::::", res)
        setList(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.error("Error fetching social_media:", err);
        setList([]); // fail safe
      });
  };

  const fetchPolicies = () => {
    Getdata(
      `${process.env.REACT_APP_URL}/front/policies/${process.env.REACT_APP_SUBDOMAIN}`
    )
      .then((res) => {
        console.log('res:::::::::::::: ', res);
        if (res && Array.isArray(res.data)) {
          setPolicies(res.data); // directly set the array
        } else {
          setPolicies([]); // fallback if data is not an array
        }
      })
      .catch((err) => {
        console.error("Error fetching policies:", err);
        setPolicies([]); // fail safe
      });
  };


  useEffect(() => {
    fetchData();
    fetchPolicies();
  }, []);

  return (
    <footer className="bg-black text-white text-left py-10 ">
      <div className="container mx-auto w-full px-4 md:px-10 flex flex-col md:flex-row justify-center gap-y-8 md:gap-x-20">
        {/* Left */}
        <div className="text-base">
          <div className="flex items-center gap-3 mb-4">
            <img src={props.data?.logo} alt="logo" className="object-contain w-20 h-20" />
            <span className="text-base font-bold ">{props.data?.name}</span>
          </div>
          <div className="flex items-center gap-2 mb-2">
            <MdPhone className="text-2xl" />
            <span className="w-10">{props.data?.school_mobile_number}</span>
          </div>
          <div className="flex items-center gap-2 mb-2">
            <MdEmail className="text-2xl" />
            <span>{props.data?.school_email}</span>
          </div>
          <div className="flex items-start text-left gap-2 max-w-xs leading-relaxed">
            <MdLocationOn className="mt-1 text-2xl flex-shrink-0" />
            <ul className="space-y-1">
              <li>
                {props.data?.address} {props.data?.city}, {props.data?.country}
              </li>
              <li>{props.data?.addressline}</li>
            </ul>
          </div>

          {/* 3) Render only the platforms that exist in API data */}
          <div className="flex gap-3 mt-4">
            {socialLinks.map(({ name, href, icon }) => (
              <a
                key={name}
                href={href}
                aria-label={name}
                className="hover:opacity-75 transition"
                target="_blank"
                rel="noopener noreferrer"
              >
                {icon}
              </a>
            ))}
          </div>
        </div>

        {/* Middle + Right unchanged */}
        <div className="flex flex-col md:flex-row justify-end gap-8 md:gap-x-20 w-full text-base">
          <div>
            <h3 className="font-semibold mb-3">
              <b>Quick Links</b>
            </h3>
            <ul className="space-y-2">
              {QuickLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path} 
                    onClick={() => {
                      if (window.location.pathname === link.path) {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                    className="hover:underline cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-3">
              <b>Others</b>
            </h3>
            <ul className="space-y-2">
              {policies.map((policy) => (
                <li key={policy.title}>
                  <Link 
                    to={`others/${policy._id}`}  
                    onClick={() => {
                      if (window.location.pathname === `/others/${policy._id}`) {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                    className="hover:underline cursor-pointer"
                  >
                    {policy.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

